import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { IInwardWorstODPairs } from "./models/widget-inward-worst-od-pairs";
import { InwardWorstODPairsService } from "./services/widget-inward-worst-od-pairs.service";
import * as HSET from "./settings";
import { GenericUtils } from "./../../../utilities/generic-utils";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Params } from "@angular/router";
import { CommonService } from "../../../../shared/services";
@Component({
  selector: "app-widget-inward-worst-od-pairs",
  templateUrl: "./widget-inward-worst-od-pairs.component.html",
  styleUrls: ["./widget-inward-worst-od-pairs.component.scss"],
  providers: [InwardWorstODPairsService]
})
export class WidgetInwardWorstODPairsComponent implements OnInit, OnChanges, OnDestroy{
  private unsubscribe: Subject<void> = new Subject();
  @Input() TITLE: string;
  @Input() HEADINGS: string[] = [];
  @Input() FILTERS: object = {};
  @Input() OPTIONS: object;
  data = null;
  errorMessage = "";
  mockData = null;

  constructor(
    private returnWorstPairService: InwardWorstODPairsService,
    private utils: GenericUtils,
    private commonService: CommonService,
    private activateRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const intiFilter = JSON.parse(JSON.stringify(this.FILTERS))
    this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
      if (Object.keys(params).length) {
        this.FILTERS = this.commonService.getFiltersParams(params, this.FILTERS);
        this.getReturnWorstPairService();
      } else {
        this.FILTERS=JSON.parse(JSON.stringify(intiFilter));
        this.getReturnWorstPairService();
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      
    }
  }

  getReturnWorstPairService() {
    this.errorMessage = "";
    this.data = null;
    this.mockData = null;
    const query = JSON.parse(JSON.stringify(this.FILTERS));
    query.limit = "7";
    this.returnWorstPairService.getWorstODPairs(this.OPTIONS, query)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        response => {
          if (response.data.length) {
            this.data = response.data;
            this.data.map(worstPair => {
              worstPair.value = this.utils.amountIndianUnit(worstPair.value);
            });
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockData = HSET.data;
            this.HEADINGS = HSET.displayedColumns5;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockData = HSET.data;
          this.HEADINGS = HSET.displayedColumns5;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
